<template>
  <b-col md="9" id="moreContent">
    <!-- Additional filters -->
    <FiltersAboveProducts
      :appliedFilters="appliedFilters"
      :resultsNum="resultsNum"
      v-on:remove-filter="removeFilter"
      v-on:change-sort="changeSort"
      v-on:clear-all="$emit('clear-all')"
    />

    <b-container fluid id="productsArea">
      <!-- Actual products -->

      <b-row class="productsRow" :key="appliedFilters">
        <ProductCard
          v-for="product in paginatedProducts"
          :key="product.Item_id"
          :prodDetails="product"
          :filter="appliedFilters"
        />
      </b-row>
      <!-- Pagination -->

      <nav aria-label="Products Navigation">
        <ul class="pagination justify-content-center">
          <li class="page-item" v-if="currPage > 1">
            <a class="page-link" href="#" v-on:click="currPage= 1" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">Previous</span>
            </a>
          </li>
          <li
            class="page-item"
            v-for="page  in maxPages"
            :class="{active: page == currPage}"
            v-on:click="currPage = page"
            :key="page"
            v-if="page >= minPages"
          >
            <a class="page-link" href="#">{{page}}</a>
          </li>
          <li class="page-item" v-if="currPage < totalPages">
            <a class="page-link" href="#" v-on:click="currPage = totalPages" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
        </ul>
      </nav>
    </b-container>
  </b-col>
</template>

<style scoped>
.page-item .page-link {
  background-color: inherit;
  border-color: transparent;
  color: black;
}
.page-item.active .page-link {
  font-weight: bold;
}
</style>
<script>
import ProductCard from "./ProductCard";
import FiltersAboveProducts from "./FiltersAboveProducts";

export default {
  name: "ProductsArea",
  components: {
    ProductCard,
    FiltersAboveProducts,
  },
  props: {
    resultsNum: Number,
    appliedFilters: Array,
    availableProducts: Array,
  },
  watch: {
    availableProducts: function () {
      this.currPage = 1;
    },
  },
  methods: {
    changeSort(sort) {
      this.$emit("change-sort", sort);
      this.currPage = 1;
    },
    removeFilter(x) {
      this.$emit("remove-filter", x);
      this.currPage = 1;
    },
  },
  computed: {
    minPages: function () {
      return this.currPage > 3 ? this.currPage - 3 : 1;
    },
    maxPages: function () {
      return this.totalPages - this.currPage > 3
        ? this.currPage + 3
        : this.totalPages;
    },
    paginatedProducts: function () {
      return this.availableProducts.slice(
        (this.currPage - 1) * this.productsPerPage,
        this.productsPerPage * this.currPage
      );
    },
    totalPages: function () {
      return Math.ceil(this.resultsNum / this.productsPerPage);
    },
  },
  data() {
    return {
      currPage: 1,
      productsPerPage: 16,
    };
  },
  mounted() {},
};
</script>

<style scoped>
.itemplaceholder {
  background-color: green;
}
</style>
